import React, { useState } from 'react';
import { offerListFilter } from '../filters';
import {
  ApplicationViewList,
  type FilterFields,
  type ApplicationViewListProps,
  type TableColumns,
  type CustomAction,
  type ApplicationViewTableDataItem,
} from '../../../../Application/components';
import { COMMON_ACTION } from '../../../../Application/components/ApplicationViewList/constants';
import { useAuth } from '../../../../../contexts';
import { RestartAlt } from '@mui/icons-material';
import GSSupersedeOfferDialog from './GSSupersedeOfferDialog';

export const GSOfferList: React.FunctionComponent = () => {
  const { user } = useAuth();

  const listFilter = offerListFilter(user);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedApplicationId, setSelectedApplicationId] =
    useState<string>('');

  const handleSupersedeOffer = (row: ApplicationViewTableDataItem): void => {
    const { applicationId } = row;
    setSelectedApplicationId(applicationId);
    setDialogOpen(true);
  };

  const visibleColumns: TableColumns[] = React.useMemo(
    () => [
      'applicationNo',
      'applicantName',
      'entryYear',
      'department',
      'applyProgramme',
      'researchAreas',
      'proposedChiefSupervisors',
      'entryYear',
      'hkpfsDisplayInformation',
      'nominatedFundings',
      'offerDate',
      'applicationStatus',
      'offerStatus',
    ],
    [],
  );

  const hiddenFilters: FilterFields[] = React.useMemo(
    () => [
      'partnerCategory',
      'applicantIdentityType',
      'applicantLocalIndicator',
      'gsAssignee',
    ],
    [],
  );

  const filterProps: ApplicationViewListProps['filterProps'] = {
    hiddenFilterFields: hiddenFilters,
  };

  const customActions: CustomAction[] = [
    {
      icon: <RestartAlt />,
      handleAction: handleSupersedeOffer,
      title: 'Supersede Offer',
      checkDisable: row => {
        return false;
      },
    },
  ];

  const tableProps: ApplicationViewListProps['tableProps'] = {
    initialVisibleColumns: visibleColumns,
    listFilter,
    pickCommonActions: [COMMON_ACTION.MONITOR, COMMON_ACTION.ONE_OFF],
    customActions,
  };

  return (
    <>
      <ApplicationViewList tableProps={tableProps} filterProps={filterProps} />
      <GSSupersedeOfferDialog
        applicationId={selectedApplicationId}
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
      />
    </>
  );
};
